import React from 'react';

type Props = {
    children?: React.ReactNode,
    actions?: {[key: string] : () => any},
    title: string,
    detail: string,
};

export default class Error extends React.Component<Props> {
    static defaultProps = {
        title: 'Es ist ein Fehler aufgetreten',
        detail: '',
    };

    renderActions() {
        const { actions } = this.props;
        if (!actions) return null;

        return Object.keys(actions).map(label => (
            <button onClick={() => actions[label]()} className="btn btn-primary">{label}</button>
        ));
    }

    render() {
        return (
            <div className="application-error">
                <h3 className="application-error-title">{this.props.title}</h3>
                <div className="application-error-detail">{this.props.detail}</div>
                {this.props.children}
                <div className="application-error-actions">
                    {this.renderActions()}
                </div>
            </div>
        );
    }
}
